import React from 'react';
import TypingTester from "../../../TypingTester";
import BaseField, {BaseFieldSelfProps, BaseFieldSelfState} from "./BaseField";

export default class FieldNumber extends BaseField<any, any> {
    tester: TypingTester;
    canAcceptValueUpdate: boolean;
    willBeUpdatedBySelf: boolean;

    constructor(props: BaseFieldSelfProps) {
        super(props)

        this.willBeUpdatedBySelf = false
        this.canAcceptValueUpdate = true
        this.tester = new TypingTester(250)
        this.state = {
            value: props.value || null,
            errorState: props.errorState,
            errorMessage: props.errorMessage,
            label: props.label
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: BaseFieldSelfProps) {
        this.setState({
            value: nextProps.value || null,
            errorState: false
        })
    }

    shouldComponentUpdate(nextProps: BaseFieldSelfProps, nextState: BaseFieldSelfState) {
        if (!this.willBeUpdatedBySelf) {
            if (nextState.value !== this.state.value && !this.canAcceptValueUpdate) {
                return false
            }
        }

        return (
            nextState.value !== this.state.value ||
            nextProps.value !== this.props.value ||
            nextProps.readonly !== this.props.readonly ||
            nextProps.disabled !== this.props.disabled ||
            nextProps.errorState !== this.props.errorState ||
            nextProps.text !== this.props.text
        )
    }

    onChange = (e: any) => {
        let val = e.target.value
        if (this.props.field.floatingPoint === false) {
            val = val.replace('.', '');
            val = val.replace(',', '');
        } else if (val && val.includes(',')) {
            val = val.replace(',', '.');
        }

        this.willBeUpdatedBySelf = true
        this.setState({value: val, errorState: false, errorMessage: ''}, () => {
            this.willBeUpdatedBySelf = false
            this.canAcceptValueUpdate = false
        })

        if (this.props.validator && !this.props.validator.validate(Number.parseFloat(val))) {
            this.setState({errorState: true, errorMessage: this.props.validator.getErrorMessage()})
            return;
        }
        // !!! Do not touch this !!!
        // !!! Store must be updated even if we're not done typing, yet !!!
        this.updateStoreValue(val)

        this.tester.record(() => {
            this.canAcceptValueUpdate = true
            this.props.onChange(val)
        })
    }

    getClassNameForInput = () => {
        let cn = '';
        if (this.state.errorState) {
            cn += ` error `
        }
        return cn;
    }
    renderInput = () => {
        let id = this.generateUniqueId()
        return (<React.Fragment>
            <input
                id={id}
                type="text"
                value={this.state.value || ''}
                onChange={this.onChange}
                className={this.getClassNameForInput()}
                readOnly={this.props.readonly}
                disabled={this.props.disabled}
            />
            {this.props.unitLabel && (<div className={`unit-label`}>{this.props.unitLabel}</div>)}
        </React.Fragment>)
    }

    renderReadOnly = () => {
        return <div className="text-field--readonly">{this.state.value} {this.props.unitLabel && (
            <span className={`unit-label--readonly`}>{this.props.unitLabel}</span>)}</div>
    }

    getLabel = (): string => {
        return `${this.state.label} ${this.props.required ? '*' : ''}`;
    }

    renderField() {
        return (
            <div className={this.getClassNames()}>
                <div className="step-input-field">
                    {this.renderLabel() && <div className="label">
                        {this.getLabel()}
                    </div>}
                    <div className="input">
                        <div className="common-input-wrapper">
                            {this.props.readonly ? this.renderReadOnly() : this.renderInput()}
                        </div>
                    </div>
                    {this.renderDescription()}
                    {this.renderErrorMessage()}
                </div>
            </div>
        )
    }
}